import { RequirementSectionDataService } from "../../core/requirementsections.dataservice";
import { AuthorityDataService } from "../../core/authorities.dataservice";
import { WorkplaceDataService } from "../../core/workplaces.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { RequirementSections } from "./requirement-sections.component";
import { EditRequirementSection } from "./requirement-section.edit.component";
import { RequirementSection } from "./requirement-section.component";

/**
 * This state displays all Requirement Sections
 */
export const requirementSectionsState: Ng2StateDeclaration = {
    name: "app.settings.requirementsections",
    url: "/requirementsections",
    views: {
        "main-view@app": {
            component: RequirementSections
        }
    },
    resolve: {
        requirementSections: [RequirementSectionDataService.Id, (requirementSectionDataService: RequirementSectionDataService) => {
            return requirementSectionDataService.getAll();
        }],
        authorities: [AuthorityDataService.Id, (authorityDataService: AuthorityDataService) => {
            return authorityDataService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Requirement Section
 */
export const newRequirementSectionState: Ng2StateDeclaration = {
    name: "app.settings.requirementsections.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditRequirementSection
        }
    },
    resolve: {
        requirementSection: function () {
            return <Nema.Crew.Model.CompetenceRequirementCollection>{
                Id: -1,
                Name: "",
                CompetenceRequirementCollectionWorkplaces: [],
                Description: "",
                HasAttachment: false
            };
        },
        authorities: [AuthorityDataService.Id, (authorityDataService: AuthorityDataService) => {
            return authorityDataService.getAll();
        }],
        workplaces: [WorkplaceDataService.Id, (workplaceDataService: WorkplaceDataService) => {
            return workplaceDataService.getAll();
        }],
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Requirement Section
 */
export const editRequirementSectionState: Ng2StateDeclaration = {
    name: "app.settings.requirementsections.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditRequirementSection
        }
    },
    resolve: {
        requirementSection: [RequirementSectionDataService.Id, "$stateParams", function (requirementSectionDataService: RequirementSectionDataService, $stateParams) {
            return requirementSectionDataService.get($stateParams.id);
        }],
        authorities: [AuthorityDataService.Id, (authorityDataService: AuthorityDataService) => {
            return authorityDataService.getAll();
        }],
        workplaces: [WorkplaceDataService.Id, (workplaceDataService: WorkplaceDataService) => {
            return workplaceDataService.getAll();
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Requirement Section Details state
 */
export const requirementSectionState: Ng2StateDeclaration = {
    name: "app.settings.requirementsections.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: RequirementSection
        }
    },
    resolve: {
        requirementSection: [RequirementSectionDataService.Id, "$stateParams", function (requirementSectionDataService: RequirementSectionDataService, $stateParams) {
            return requirementSectionDataService.get($stateParams.id);
        }],
        authorities: [AuthorityDataService.Id, (authorityDataService: AuthorityDataService) => {
            return authorityDataService.getAll();
        }],
        workplaces: [WorkplaceDataService.Id, (workplaceDataService: WorkplaceDataService) => {
            return workplaceDataService.getAll();
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/requirementsections/requirement-sections.states.ts